module.exports = __webpack_public_path__ + "img/keyvisual.6639d56c.jpg";